<template>
  <div class="news-detail-page">
    <section class="banner-section">
      <img src="@/assets/pic/news-ban.jpg" alt="新聞資訊" class="banner-img" />
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">{{ $i18n.t("news.bannerTitle") }}</h1>
        <p class="banner-subtitle">{{ $i18n.t("news.bannerDesc") }}</p>
      </div>
    </section>

    <section class="main-section">
      <div class="container detail-grid">
        <div class="content-left card-wrapper" v-if="currentNews">
          <h2 class="detail-title">{{ currentNews.title }}</h2>
          <div class="detail-meta">{{ currentNews.year_month }}-{{ currentNews.day }}</div>
          <hr class="divider" />
          
          <div class="detail-article">
            <p v-for="(paragraph, pIdx) in splitContent(currentNews.content)" :key="pIdx">
              {{ paragraph }}
            </p>
          </div>
          
          <button class="back-btn" @click="router.push('/news')">
            {{ $i18n.t("news.backToList") }}
          </button>
        </div>

        <div class="sidebar-right">

          <div class="hot-articles">
            <h3 class="sidebar-title">{{ $i18n.t("news.hotArticlesTitle") }}</h3>
            <ul class="hot-list">
              <li 
                v-for="item in hotNews" 
                :key="item.id" 
                :class="{ active: item.id === currentNews?.id }"
                @click="switchNews(item.id)"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import localNewsData from "@/mock/news.json";

const route = useRoute();
const router = useRouter();
const currentNews = ref(null);
const hotNews = ref([]);

const loadNewsDetail = (id) => {
  const found = localNewsData.find(item => item.id === parseInt(id));
  if (found) {
    currentNews.value = found;
  }
  hotNews.value = localNewsData.slice(0, 5); 
};

onMounted(() => {
  loadNewsDetail(route.params.id);
});

watch(() => route.params.id, (newId) => {
  loadNewsDetail(newId);
});

const switchNews = (id) => {
  router.push(`/news/${id}`);
};

const splitContent = (text) => {
  if (!text) return [];
  return text.split("\n").filter(p => p.trim() !== "");
};
</script>

<style scoped>
/* 详情页样式与上个版本完全一致，Banner 尺寸已锁死 */
.news-detail-page { min-height: 100vh; }
.banner-section { position: relative; width: 100%; overflow: hidden; }
.banner-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(to right, rgba(0, 20, 40) 0%, rgba(0, 20, 40, 0.78) 60%, transparent 100%); pointer-events: none; z-index: 1; }
.banner-img { width: 100%; object-fit: cover; display: block; }
.banner-content { position: absolute; top: 50%; left: 12rem; transform: translateY(-50%); z-index: 2; }
.banner-title { font-size: 3rem; font-weight: bold; color: #fff; margin-bottom: 0.75rem; letter-spacing: 0.125rem; }
.banner-subtitle { font-size: 1.2rem; color: rgba(255, 255, 255, 0.8); line-height: 1.6; max-width: 31.25rem; }

.container { max-width: 87rem; margin: 0 auto; padding: 0 1.25rem; }
.main-section { padding: 5rem 0; background-color: #fff; }
.detail-grid { display: grid; grid-template-columns: 2.2fr 1fr; gap: 3rem; align-items: start; }
.card-wrapper { background: #fff; padding: 3rem; border-radius: 4px; box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.02); border: 1px solid #f1f5f9; }
.detail-title { font-size: 1.8rem; font-weight: bold; color: #1a3a5c; margin-bottom: 0.75rem; }
.detail-meta { font-size: 0.9rem; color: #aaa; margin-bottom: 1.5rem; }
.divider { border: 0; border-top: 1px solid #eee; margin-bottom: 2rem; }
.detail-article p { font-size: 1.15rem; line-height: 2; color: #444; margin-bottom: 1.5rem; text-align: justify; }
.back-btn { margin-top: 2rem; background: none; border: 1px solid #1a3a5c; color: #1a3a5c; padding: 0.5rem 1.2rem; border-radius: 4px; cursor: pointer; transition: all 0.3s; }
.back-btn:hover { background: #1a3a5c; color: #fff; }
.sidebar-right { display: flex; flex-direction: column; gap: 2rem; }
.search-box { position: relative; background: #fff; border-radius: 4px; border: 1px solid #e5e7eb; padding: 0.75rem 1rem; display: flex; align-items: center; }
.search-box input { border: none; outline: none; width: 100%; font-size: 1rem; color: #333; }
.search-icon { cursor: pointer; }
.hot-articles { background: #fff; padding: 2rem; border-radius: 4px; box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.02); border: 1px solid #f1f5f9; }
.sidebar-title { font-size: 1.2rem; font-weight: bold; color: #1a3a5c; margin-bottom: 1.5rem; padding-left: 0.5rem; border-left: 4px solid #1a3a5c; }
.hot-list { list-style: none; padding: 0; margin: 0; }
.hot-list li { font-size: 1rem; color: #555; padding: 0.75rem 0; border-bottom: 1px dashed #eee; cursor: pointer; transition: color 0.2s; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.hot-list li::before { content: "• "; color: #1a3a5c; font-weight: bold; margin-right: 0.5rem; }
.hot-list li:hover, .hot-list li.active { color: #8b1e21; font-weight: bold; }
.hot-list li:last-child { border-bottom: none; }

@media (max-width: 48rem) {
  .banner-section { height: 17.5rem; }
  .banner-content { left: 1.875rem; }
  .banner-title { font-size: 1.5rem; }
  .banner-subtitle { font-size: 1rem; }
  .detail-grid { grid-template-columns: 1fr; gap: 2rem; }
  .card-wrapper { padding: 1.5rem; }
  .main-section { padding: 3.125rem 0; }
}
@media (max-width: 30rem) { .banner-title { font-size: 1.5rem; } }
</style>